import React, { useCallback } from "react";
import {
  Icon,
  Dialog,
  DialogContent,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@material-ui/core";

function DefaultNumberModal(props) {
  const {
    open,
    closeModal,
    name,
    onChange,
    value,
    onSubmit,
    phoneOptions,
    className,
  } = props;

  const submitData = useCallback(() => {
    closeModal();
    onSubmit();
  }, [closeModal, onSubmit]);

  return (
    <Dialog
      fullScreen={window.innerWidth < 600}
      open={open}
      //   maxWidth="sm"
      //   fullWidth={true}
      onClose={closeModal}
      classes={{
        root: "add-new-number-modal pastorsline",
        paper: "paper number-modal",
      }}
    >
      <Typography className="title">
        Select default number
        <Icon className="close-icon" onClick={closeModal}>
          close
        </Icon>
      </Typography>
      <DialogContent className="content modal-numbers-wrapper flexer-col">
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          name={name}
          value={value}
          onChange={onChange}
          className={`w-100 mb-4 mt-3 ${className}`}
        >
          {phoneOptions.map((item, index) => (
            <MenuItem key={index} value={item.key}>
              {item.value}
            </MenuItem>
          ))}
        </Select>
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={submitData}
          classes={{
            root: "btn mb-2 w-100",
            label: "label",
            containedPrimary: "contained-primary",
          }}
        >
          Save
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default DefaultNumberModal;
